import React from 'react';
import { FormattedMessage } from 'react-intl';
import css from './faq.module.css';

const PhotoTips = () => {
  return (
    <div className={css.photoTips}>
      <p>
        <FormattedMessage id="faq.photoTips.intro" />
      </p>

      <p>
        <FormattedMessage id="faq.photoTips.suggestions" />
      </p>

      <ul className={css.bulletList}>
        <li>
          <FormattedMessage id="faq.photoTips.firstPhoto" />
        </li>

        <li>
          <FormattedMessage id="faq.photoTips.closeUp" />
        </li>

        <li>
          <FormattedMessage id="faq.photoTips.showDefects" />
        </li>

        <li>
          <FormattedMessage id="faq.photoTips.ownPhotos" />
        </li>

        <li>
          <FormattedMessage id="faq.photoTips.trueColours" />
        </li>
      </ul>
    </div>
  );
};

export default PhotoTips;
